var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 px-3"},[_c('h5',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm.$t('appointment.label.cancellationOrigin'))+" ")]),_c('p',{staticClass:"text-body-2 mb-0"},[_vm._v(" "+_vm._s(_vm.cancelReason)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }